import React from "react";
import { cn } from "@/lib/utils";
import {
  ICANN_OPEN_LABEL,
  ICANN_CLOSE_LABEL,
  ICANN_CLOSE_ISO,
  daysUntilISO,
} from "@shared/campaign";

/**
 * StewardStrip — thin urgency band above the top nav.
 *
 * Layout:
 *   [Stewardship note]  |  [ICANN window dates]  |  [PULSING PILL] continuation text
 *
 * The pill is the only prominent element. Everything else reads as
 * governance metadata and sits in muted mono text.
 */
export function StewardStrip({ className }: { className?: string }) {
  const daysLeft = Math.max(0, daysUntilISO(ICANN_CLOSE_ISO));
  return (
    <div
      role="status"
      aria-label={`${daysLeft} days left until the ICANN domain submission window closes`}
      className={cn(
        "w-full bg-paper-2 border-b border-hairline font-mono text-[10px] text-ink-3 uppercase tracking-widest",
        className
      )}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex flex-wrap items-center justify-center md:justify-between gap-x-6 gap-y-1.5 text-center">
        <span className="hidden md:inline whitespace-nowrap">
          Stewarded by the .person Foundation · 501(c)(3) in formation
        </span>
        <span className="md:hidden whitespace-nowrap">501(c)(3) in formation</span>

        <span className="hidden lg:inline whitespace-nowrap">
          ICANN window {ICANN_OPEN_LABEL} → {ICANN_CLOSE_LABEL}
        </span>

        <span className="inline-flex items-center gap-2 flex-wrap justify-center">
          <span
            className="bg-claude text-paper font-bold px-3 py-1 rounded-full animate-claude-pulse whitespace-nowrap tracking-widest"
            aria-hidden="true"
          >
            {daysLeft} Days Left
          </span>
          <span className="text-ink-2 whitespace-nowrap">
            to ICANN Window Close
          </span>
        </span>
      </div>
    </div>
  );
}
